export const useAddressApi = () => useApi<Address[]>('/addresses')
